<template>
  <div class="text-dark w-100 h-100 d-flex flex-column">
    <div class="bg-img" />
    <div
      id="main-view-content"
      class="
        responsivePosition
        bg-opacity-75
        px-3
        d-flex
        flex-column
        justify-content-center
      "
    >
      <h3 class="card-title fw-bold py-3">
        Welcome to the CE 365 Spiral Curve Survey Simulation!
      </h3>
      <div class="fs-5">
        <p class="card-text text-left">
          Through the course of the simulation you will be staking points for a
          spiral curve on one of the dairy fields on the western side of the OSU
          campus. Using simulated surveying tools like the total station, you
          will take measurements and perform calculations exactly the same way
          real surveyors do every day.
        </p>
        <p class="card-text mb-3">
          Make sure you have your field notebook handy before starting the
          simulation.
        </p>
      </div>
      <div
        class="w-100 text-center pb-3 d-flex flex-row justify-content-evenly"
      >
        <div>
          <router-link
            class="btn btn-primary btn-lg fw-bold text-center"
            :to="{ name: 'Activity' }"
            data-cy="start-button"
          >
            START
          </router-link>
        </div>
        <div>
          <router-link
            :to="{ name: 'Participants' }"
            v-if="isAdmin"
            class="btn btn-secondary btn-lg fw-bold text-center"
            >ADMIN INTERFACE</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LandingView",
  components: {},
  props: {},
  computed: {
    ...mapGetters(["showNavbar", "isAdmin"])
  }
};
</script>

<style scoped>
/* See: https://stackoverflow.com/a/60035493 */
.bg-img {
  background: no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-image: url(../assets/total_station_at_community_hall.jpg);
  height: 256px;
}

.bg-img + #main-view-content {
  z-index: 1;
}
.responsivePosition {
  position: default;
}

@media (min-width: 992px) {
  .responsivePosition {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: auto;
  }
  #main-view-content {
    width: 50%;
    height: 100%;
    background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
}
</style>
